import axios from "axios";
import Modal from "react-modal";
import moment from "moment";
import { AES } from 'crypto-js';
import { DatePicker } from "rsuite";
import subDays from "date-fns/subDays";
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import Tooltip from "../InvoiceCreateManual/Tooltip";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect, useRef } from "react";
import userCategory from "../../../constants/userCategory.js";
import userTypeConsts from "../../../constants/userTypeConsts";
import css from "../InvoiceCreateManual/InvoiceCreateManual.css";
import { logout, reset } from "../../../features/auth/authSlice";
import dletImage from "../../../images/singleinvoice/delete.svg";
import whatis from "../../../images/singleinvoice/whatisthis.svg";
import cancelImage from "../../../images/singleinvoice/cancel.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import addicoplus from "../../../images/singleinvoice/plus-add-icon.svg";
import CompanyDocumentField from "../../User/elements/CompanyDocumentField";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { setNotification } from "../../../features/notification/notificationSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import CalendarIcon from '../../ui/CalendarIcon';

const InvoiceEditManual = (props) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [userName, setUserName] = useState("");
  const [selUserCategory, setSelUserCategory] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invType, setInvType] = useState("Regular");
  const [issueDate, setIssueDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const lastDayOfMonth = new Date(year, month + 1, 0);
    return lastDayOfMonth;
  });
  const [title, setTitle] = useState("");
  const [subTotal, setSubTotal] = useState("00.00");
  const [taxTotal, setTaxTotal] = useState("00.00");
  const [total, setTotal] = useState("00.00");
  const [productDetails, setProductDetails] = useState([
    { description: "", projectId: "", cost: "", tax: "", price: "" },
  ]);
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [invDocument, setInvDocument] = useState(null);
  const [invDocumentFileName, setInvDocumentFileName] = useState("");
  const [invFiles, setInvFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [filesToRemove, setFilesToRemove] = useState([]);
  const [otherComnt, setOtherComnt] = useState("");
  const [selUserEmail, setSelUserEmail] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [updateIsLoading, setUpdateIsLoading] = useState(false);
  const [invoiceBank, setInvoiceBank] = useState("");
  const [invoiceBankListName, setInvoiceBankListName] = useState("");
  const [invoiceBankCurrency, setInvoiceBankCurrency] = useState("");
  const [projectId, setProjectId] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [invoiceView, setInvoiceView] = useState([]);
  const [selUserId, setSelUserId] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isBankLoading, setBankIsLoading] = useState(true);
  const [invTypeDropdownOpen, setInvTypeDropdownOpen] = useState(false);
  const [searchBankAccountTerm, setSearchBankAccountTerm] = useState('');
  const [bankAccountDropdownOpen, setBankAccountDropdownOpen] = useState(false);
  const [dateRangeIsValid, setDateRangeIsValid] = useState(false);
  const dateRangeRef = useRef(null);
  const [issueDateIsValid, setIssueDateIsValid] = useState(false);
  const issueDateRef = useRef(null);
  const [dueDateIsValid, setDueDateIsValid] = useState(false);
  const dueDateRef = useRef(null);
  const [titleIsValid, setTitleIsValid] = useState(false);
  const titleRef = useRef(null);
  const [descriptionIsValid, setDescriptionIsValid] = useState(false);
  const [expenseCategoryIsValid, setExpenseCategoryIsValid] = useState(false);
  const descriptionRef = useRef(null);
  const [costIsValid, setCostIsValid] = useState(false);
  const costRef = useRef(null);
  const [taxIsValid, setTaxIsValid] = useState(false);
  const taxRef = useRef(null);
  const invTypeDropdownRef = useRef(null);
  const bankAccountDropdownRef = useRef(null);
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 991);
  const [fromCalendarOpen, setFromCalendarOpen] = useState(false);
  const [toCalendarOpen, setToCalendarOpen] = useState(false);
  const [issueCalendarOpen, setIssueCalendarOpen] = useState(false);
  const [dueCalendarOpen, setDueCalendarOpen] = useState(false);
  const [newLineModalOpen, setNewLineModalOpen] = useState(false);
  const [newLineDesc, setNewLineDesc] = useState('');
  const [newLineCost, setNewLineCost] = useState('');
  const [newLineVat, setNewLineVat] = useState('');

  const formatDateStr = (d) => {
    if (!d) return "DD/MM/YYYY";
    return moment(d).format("DD/MM/YYYY");
  };

  const handleAddLineItemSubmit = (e) => {
    e.preventDefault();
    if (!newLineDesc && !newLineCost) return;
    const costNum = parseFloat(newLineCost) || 0;
    const taxNum = parseFloat(newLineVat) || 0;
    const amountNum = (costNum + (costNum * (taxNum / 100))).toFixed(2);
    const newRow = { description: newLineDesc, cost: newLineCost, tax: newLineVat, amount: amountNum };
    const updated = [...productDetails, newRow];
    setProductDetails(updated);

    const { subTotal: newSub, taxTotal: newTax } = calculateSubTotalAndTax(updated);
    setSubTotal(newSub);
    setTaxTotal(newTax);
    setTotal(newSub);

    setNewLineDesc('');
    setNewLineCost('');
    setNewLineVat('');
    setNewLineModalOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const { appSettings } = useSelector((state) => state.appSettings);
  let token = null;
  let createdBy = null;
  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
      createdBy = user._id;
    }
  }


  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const handleSelect = (ranges) => {
    // DateRangePicker returns an array [startDate, endDate]
    if (Array.isArray(ranges)) {
      setDateRange(ranges);
    } else if (ranges && ranges.selection) {
      // Handle object format with selection property
      setDateRange([ranges.selection.startDate, ranges.selection.endDate]);
    }
  };

  useEffect(() => {
    async function fetchInvoice() {
      try {
        setIsLoading(true);
        const response = await axios.get(`/api/invoice/${props.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data;
        const invoiceDetails = data.inv_description;
        var projectIds = data.inv_projectId || projectId.find(project => project.project_name === data.inv_description)._id || null;
        var costs = data.inv_cost;
        var category = data.inv_category;
        const vats = data.inv_tax;
        const prices = data.inv_price;
        const invoiceViewData = invoiceDetails.map((item, index) => {
          return {
            Description: item.trim(),
            ProjectId: projectIds[index],
            Cost: costs[index],
            Category: category[index],
            tax: vats[index],
            amount: prices[index],
          };
        });
        setInvoiceView([{ ...data, Invoice_Details: invoiceViewData }]);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      }
    }
    fetchInvoice();

  }, [props.id]);

  useEffect(() => {
    async function fetchUser() {
      try {
        const response = await axios.get(`/api/user/data/${selUserEmail && selUserEmail}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        let userName = '';
        if (response.data.first_name && response.data.first_name?.toLowerCase() !== 'null') {
          userName = response.data.first_name;
          if (response.data.middle_name && response.data.middle_name?.toLowerCase() !== 'null') {
            userName += ' ' + response.data.middle_name;
          }
          userName += ' ' + response.data.last_name;
        } else {
          userName = response.data.company_name;
        }
        if (response.data) {
          setUserName(userName || "");
          setSelUserCategory(response.data.user_category || "");
          setSelUserId(response.data._id || null);
        }
      } catch (err) {
        console.log(err);
        global.config.slackMessage(err.toString());
      }
    }
    fetchUser();
    async function fetchExpenseCategory() {
      try {
        const response = await axios.get("/api/expense-categories", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setExpenseCategory(response.data)
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        alert("Something went wrong while fetching invoice number");
      }
    }
    fetchExpenseCategory();
    async function fetchBank() {

      try {
        setBankIsLoading(true);
        const response = await axios.get(
          `/api/wise/user/banks/${selUserEmail}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
        );
        setBankDetails(response.data);
        setBankIsLoading(false);
      } catch (error) {
        global.config.slackMessage(error.toString());
        if (error.response && error.response.status === 404) {

        } else if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
      }
    }
    if (selUserEmail) {
      fetchBank();
    }
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };

  }, [selUserEmail]);

  useEffect(() => {
    async function fetchProjectId() {
      try {
        const response = await axios.get("/api/all/project-details", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setProjectId(response.data);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      }
    }
    fetchProjectId();
  }, []);

  useEffect(() => {
    if (!isLoading && invoiceView) {
      const item = invoiceView[0];
      const invoiceDetails = item.Invoice_Details;
      setSelUserEmail(item.inv_email);
      setInvoiceNumber(item.inv_number);
      setInvType(item.inv_type);
      setDateRange([new Date(item.inv_start_date || item.inv_strat_date), new Date(item.inv_end_date)]);
      setIssueDate(new Date(item.inv_issue_date));
      setDueDate(new Date(item.inv_due_date));
      setTitle(item.inv_title || "");
      setInvoiceBank(item.inv_bank || "");
      setInvoiceBankCurrency(item.inv_currency || "");
      setInvoiceBankListName(`${item.inv_bank || ""}_${item.inv_currency || ""}`);

      if (item.inv_type === "Reimbursement") {
        const productDetails = invoiceDetails.map((item1) => ({
          description: item1.Description || "",
          projectId: item1.ProjectId || "",
          cost: item1.Cost || "",
          expenseCategory: item1.Category || "",
          tax: item1.tax || "",
          amount: item1.amount || "",
          price: item1.amount || "",
        }));
        setProductDetails(productDetails);
      } else {
        const productDetails = invoiceDetails.map((item1) => ({
          description: item1.Description || "",
          projectId: item1.ProjectId || "",
          cost: item1.Cost || "",
          tax: item1.tax || "",
          amount: item1.amount || "",
          price: item1.amount || "",
        }));
        setProductDetails(productDetails);
      }
      setOtherComnt(item.inv_other_comments || "");
      if (item.inv_file && Array.isArray(item.inv_file)) {
        setExistingFiles(item.inv_file);
      } else if (item.inv_file) {
        setInvDocumentFileName(item.inv_file);
      }
      setTotal(item.inv_total_amount);
      setTaxTotal(item.inv_total_tax);
      setSubTotal(item.inv_total_amount);
    }

  }, [invoiceView, isLoading])

  const handleIssueDateChange = (date) => {
    if (!dueDate || new Date(date) <= new Date(dueDate)) {
      setIssueDate(date);
    } else {
      toast.error("Issue date must be before due date", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const ranges = [
    {
      label: "today",
      value: new Date(), // Use a single date instead of an array
    },
    {
      label: "yesterday",
      value: subDays(new Date(), 1),
    },
  ];

  const handleDueDateChange = (date) => {
    if (!issueDate || new Date(date) >= new Date(issueDate)) {
      setDueDate(date);
    } else {
      toast.error("Due date must be after issue date", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleAddRow = (e) => {
    e.preventDefault();
    const newProductDetails = [
      ...productDetails,
      { description: "", projectId: "", cost: "", tax: "", price: "" },
    ];
    setProductDetails(newProductDetails);
  };

  const handleRemoveRow = (indexToRemove, e) => {
    const newProductDetails = [...productDetails];
    newProductDetails.splice(indexToRemove, 1);
    setProductDetails(newProductDetails);
    const { subTotal, taxTotal } = calculateSubTotalAndTax(newProductDetails);
    setSubTotal(subTotal);
    setTaxTotal(taxTotal);
    const total = calculateTotal(subTotal, taxTotal);
    setTotal(subTotal);
  };

  const calculateSubTotalAndTax = (details) => {
    let subTotal = 0;
    let taxTotal = 0;
    details.forEach((detail) => {
      var cost = parseFloat(detail.cost) || 0;
      var tax = parseFloat(detail.tax) || 0;
      const amount = cost + cost * (tax / 100);
      subTotal += amount;
      taxTotal += amount - cost;
    });
    return { subTotal: subTotal.toFixed(2), taxTotal: taxTotal.toFixed(2) };
  };

  const handleInputChange = (event, index, field) => {
    const { name, value } = event.target;
    const newProductDetails = [...productDetails];
    // Ensure value is always a string, never undefined or null
    newProductDetails[index][name] = value || "";
    if (field === "cost" || field === "tax") {
      const cost = parseFloat(newProductDetails[index].cost) || 0;
      const tax = parseFloat(newProductDetails[index].tax) || 0;
      if (!isNaN(cost) && !isNaN(tax)) {
        newProductDetails[index].amount = (cost + cost * (tax / 100)).toFixed(
          2
        );
      }
    }
    setProductDetails(newProductDetails);
    const tax = calculateTax();
    setTaxTotal(tax);
    const subtotal = calculateSubtotal();
    setSubTotal(subtotal);
    const total = calculateSubtotal();
    setTotal(total);
  };

  const handleProjIdInputChange = (event, index, field) => {
    const newProductDetails = [...productDetails];
    newProductDetails[index]["projectId"] = field;
    setProductDetails(newProductDetails);
  };

  const calculateSubtotal = () => {
    let subtotal = 0;
    productDetails.forEach((detail) => {
      const cost = parseFloat(detail.cost) || 0;
      const tax = parseFloat(detail.tax) || 0;
      const amount = cost + cost * (tax / 100);
      subtotal += amount;
    });
    return subtotal.toFixed(2);
  };

  const calculateTax = () => {
    let taxs = 0;
    productDetails.forEach((detail) => {
      const cost = parseFloat(detail.cost) || 0;
      const tax = parseFloat(detail.tax) || 0;
      const amount = cost + cost * (tax / 100);
      taxs += amount - cost;
    });
    return taxs.toFixed(2);
  };

  const calculateTotal = () => {
    const subtotal = parseFloat(calculateSubtotal());
    const tax = parseFloat(calculateTax());
    return (subtotal + tax).toFixed(2);
  };

  const handleInvTypeToggleDropdown = () => {
    setInvTypeDropdownOpen(!invTypeDropdownOpen);
  };

  const handleInvTypeSelectOption = (value) => {
    setInvType(value);
    setInvTypeDropdownOpen(false);
  };

  const handleToggleDropdown = () => {
    setSearchBankAccountTerm('');
    setBankAccountDropdownOpen(!bankAccountDropdownOpen);
  };

  const handleSelectOption = (invoiceBank) => {
    const bankSelect = invoiceBank.split("_");
    setInvoiceBankCurrency(bankSelect[1]);
    setInvoiceBank(bankSelect[0]);
    setInvoiceBankListName(invoiceBank);
    setBankAccountDropdownOpen(false);
  };

  const handleSearchInputChange = (e) => {
    setSearchBankAccountTerm(e.target.value);
  };

  function openModal() { setModalIsOpen(true); }
  function closeModal() { setModalIsOpen(false); }

  function addBank() {
    if (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) {
      if (selUserId) {
        const encryptedId = AES.encrypt(selUserId, 'encryptionKey').toString();
        const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
        localStorage.setItem('activeTab', '1');
        navigate(`../profile/${encodedId}`);
      }
    } else {
      localStorage.setItem('activeTab', '1');
      navigate(`../profile/settings`);
    }
  }

  const filteredBankDetails = bankDetails.filter((bank) =>
    `${bank.details.accountNumber || ''} ${bank.details.IBAN || ''} ${bank.currency || ''} ${bank.country || ''}`
      ?.toLowerCase()
      .includes(searchBankAccountTerm?.toLowerCase())
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDateRangeIsValid(false);
    setIssueDateIsValid(false);
    setDueDateIsValid(false);
    if (
      invoiceNumber === "" ||
      issueDate === null ||
      dueDate === null ||
      !dateRange || !Array.isArray(dateRange) || dateRange.length !== 2 || !dateRange[0] || !dateRange[1] ||
      title === "" ||
      selUserEmail === "" ||
      productDetails[0].description.length === 0 ||
      productDetails[0].cost.length === 0 ||
      productDetails[0].amount.length === 0 ||
      invoiceBankCurrency === "" ||
      invType === "" ||
      invoiceBank === ""
    ) {
      if (!dateRange || !Array.isArray(dateRange) || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]) {
        setDateRangeIsValid(true);
        toast.error("Date range cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dateRangeRef.current.focus();
        return;
      } else if (issueDate === null) {
        setIssueDateIsValid(true);
        toast.error("Issue date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        issueDateRef.current.focus();
        return;
      } else if (dueDate === null) {
        setDueDateIsValid(true);
        toast.error("Due date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dueDateRef.current.focus();
        return;
      }
      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    setUpdateIsLoading(true);
    const descriptions = productDetails.map((product) => product.description);
    const projectIds = productDetails.map((product) => product.projectId);
    var expenseCategory = [];
    if (invType === "Reimbursement") {
      expenseCategory = productDetails.map((product) => product.expenseCategory);
    }
    const prices = productDetails.map((product) => product.amount);
    const costs = productDetails.map((product) => product.cost);
    const taxes = productDetails.map((product) => product.tax);
    const invoiceData = {
      inv_number: invoiceNumber,
      inv_start_date: dateRange[0],
      inv_end_date: dateRange[1],
      inv_issue_date: issueDate,
      inv_due_date: dueDate,
      inv_title: title,
      inv_description: JSON.stringify(descriptions),
      inv_projectId: JSON.stringify(projectIds),
      inv_category: JSON.stringify(expenseCategory),
      inv_price: JSON.stringify(prices),
      inv_cost: JSON.stringify(costs),
      inv_tax: JSON.stringify(taxes),
      inv_sub_total: subTotal,
      inv_total_tax: taxTotal,
      inv_total_amount: total,
      inv_currency: invoiceBankCurrency,
      inv_type: invType,
      inv_bank: invoiceBank,
      inv_other_comments: otherComnt,
      inv_created_by: createdBy,
    };

    const formData = new FormData();
    // formData.append("inv_file", invDocument);
    for (let i = 0; i < invFiles.length; i++) {
      formData.append("inv_file", invFiles[i]);
    }

    // Add files to remove
    for (let i = 0; i < filesToRemove.length; i++) {
      formData.append("files_to_remove", filesToRemove[i]);
    }

    for (let key in invoiceData) {
      formData.append(key, invoiceData[key]);
    }

    try {
      const response = await axios.put(
        `/api/invoice/update/${props.id}`,
        formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      if (data.status === "Error") {
        global.config.activityLog(window.location.href, 'Invoice', `Something went wrong while updating invoice "${invoiceNumber}"`);
        alert("Something Went Wrong");
      } else if (data.status === "statusMonthlyError") {
        alert("Cannot update this invoice as it is already Reviwed or is Monthly Invoice");
      } else {
        toast.success("Invoice updated successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(setNotification(Date.now()));
        global.config.activityLog(window.location.href, 'Invoice', `Invoice "${invoiceNumber}" Updated successfully.`);
        navigate(`../invoice/view/${props.id}`);
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      global.config.activityLog(window.location.href, 'Invoice', `Something went wrong for invoice update`);
      alert("Something went wrong");
    }
    setUpdateIsLoading(false);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideInvTypeDropdown = invTypeDropdownRef.current && invTypeDropdownRef.current.contains(event.target);
    const isClickInsideBankAccountDropdown = bankAccountDropdownRef.current && bankAccountDropdownRef.current.contains(event.target);
    if (!isClickInsideInvTypeDropdown) {
      setInvTypeDropdownOpen(false);
    }
    if (!isClickInsideBankAccountDropdown) {
      setBankAccountDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv", "jpeg", "jpg", "png", "gif"];
  const handleInvDocChange = (event) => {
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 0) {
      if (selectedFiles.length + invFiles.length > 10) {
        // Display toast error message when the total number of files exceeds 10
        toast.error('Maximum of 10 files can be uploaded!', {
          position: 'bottom-right',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      const newFiles = Array.from(selectedFiles);

      // Validate file extensions and update state
      const validFiles = newFiles.filter((file) => {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          return true;
        } else {
          toast.error(`Invalid file format for ${file.name}. Allowed formats are pdf, doc, docx, xls, xlsx, csv, jpeg, jpg, png, gif.`, {
            position: 'bottom-right',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return false;
        }
      });

      // Update the state with the valid files
      setInvFiles((prevFiles) => [...prevFiles, ...validFiles]);

      // Clear the file input for multiple selections
      fileInputRef.current.value = '';
    }
  };
  const removeFile = (index) => {
    // Remove the file at the specified index
    setInvFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };

  const downloadExistingFile = async (filename) => {
    try {
      const response = await axios.get(`/api/invoice/download/${encodeURIComponent(filename)}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Failed to download file", {
        position: "bottom-right",
        autoClose: 2000,
      });
    }
  };

  const removeExistingFile = (index) => {
    const fileToRemove = existingFiles[index];
    // Add to files to remove list
    setFilesToRemove([...filesToRemove, fileToRemove]);
    // Remove from display (but keep in existingFiles for potential undo)
    const newExistingFiles = [...existingFiles];
    newExistingFiles.splice(index, 1);
    setExistingFiles(newExistingFiles);

    // Show a toast to indicate the file will be removed on save
    // toast.info(`"${fileToRemove}" will be removed when you save the invoice`, {
    //   position: "bottom-right",
    //   autoClose: 3000,
    // });
  };

  const undoRemoveFile = (fileToRestore) => {
    // Remove from files to remove list
    setFilesToRemove(filesToRemove.filter(file => file !== fileToRestore));
    // Add back to existing files display
    setExistingFiles([...existingFiles, fileToRestore]);

    toast.success(`"${fileToRestore}" restored`, {
      position: "bottom-right",
      autoClose: 2000,
    });
  };

  const clearAllPendingChanges = () => {
    // Restore all removed files
    setExistingFiles([...existingFiles, ...filesToRemove]);
    setFilesToRemove([]);
    // Clear new files
    setInvFiles([]);

    // toast.info("All pending file changes cleared", {
    //   position: "bottom-right",
    //   autoClose: 2000,
    // });
  };
  const handleDropdownChange = (event) => {
    selectBankAccount(event.target.value);
  };
  const selectBankAccount = (invoiceBank) => {
    const bankSelect = invoiceBank.split("_");
    setInvoiceBankCurrency(bankSelect[1]);
    setInvoiceBank(bankSelect[0]);
    setInvoiceBankListName(invoiceBank);

  };
  const handleTooltipToggle = () => {
    setShowTooltip(!showTooltip);
  };
  const fileInputRef = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    setTimeout(() => {
      e.target.focus()
    }, 0)
  }

  return (
    <div className="s1-containauto">
      <form onSubmit={handleSubmit}>
        <div className="mobile-back-all-invoices-header">
          <Link to="/user/invoices" className="mobile-back-all-invoices-link">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 9L1 5L5 1" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to All Invoices
          </Link>
        </div>
        <div className="fs-head-autoinvo">
          <div className="bill-num-si">
            {isLoading ? (
              <div
                style={{
                  width: "150px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            ) : (
              <Link className="invoice-num-01">{invoiceNumber}</Link>
            )}
          </div>
          <div className="btn-aary">
            <Link to={`/user/invoice/view/${props.id}`} className="cancelbtn-link">
              <img src={cancelImage} alt="cancel" /> Cancel Invoice
            </Link>
          </div>
        </div>
        <div className="m-edit-main">
          <div className="edit-sheet-manual01">
            <div className="headder-outter-res-mainu">
              <div className="sheet-manual-header">
                <div className="type-dropdown-em">
                  <div className="dp-main-head-em">Type</div>
                  <div className="custom-dropdown">
                    {isLoading ? (
                      <div
                        className="custom-dropdown-user-new-outer"
                        style={{
                          pointerEvents: "none",
                          cursor: "default",
                          position: "relative",
                          width: "100%",
                        }}
                      >
                        <div
                          className="custom-dropdown-user-new"
                          style={{
                            backgroundColor: "#e5e7eb",
                            border: "0.2px solid rgba(106, 121, 136, 0.7)",
                            borderRadius: "7px",
                            width: "100%",
                            height: "43px",
                            paddingLeft: "16px",
                            paddingRight: "40px",
                            display: "flex",
                            alignItems: "center",
                            animation: "pulse 1.5s ease-in-out infinite",
                            boxSizing: "border-box",
                            position: "relative",
                            backgroundImage: "none",
                          }}
                        >
                          <span
                            style={{
                              width: "120px",
                              height: "19px",
                              backgroundColor: "rgba(255, 255, 255, 0.6)",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                              display: "inline-block",
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div ref={invTypeDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${invTypeDropdownOpen ? 'open' : ''}`}>
                        <div className="selected-option custom-dropdown-user-new" onClick={handleInvTypeToggleDropdown}>
                          <span>{invType ? invType : 'Select Type'}</span>
                          <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="type-dropdown-arrow-icon dropdown-chevron-icon">
                            <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                        {invTypeDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <ul className="type-list">
                              <li className={invType === 'Regular' ? 'selected-item' : ''} onClick={() => handleInvTypeSelectOption('Regular')}>Regular Invoice</li>
                              <li className={invType === 'Reimbursement' ? 'selected-item' : ''} onClick={() => handleInvTypeSelectOption('Reimbursement')}>Reimbursement Invoice</li>
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                    <span className="custom-arrow"></span>
                  </div>
                  <div className="tactic00i">
                    <img
                      src={whatis}
                      alt="tool-tip"
                      onMouseEnter={handleTooltipToggle}
                      onMouseLeave={handleTooltipToggle}
                    />
                  </div>
                </div>
                <div className="invo-date-rangeme">
                  <div className="invo-date-range-tile">Date Range</div>
                  {isMobile ? (
                    <div className="mobile-date-range-container">
                      <div className="mobile-date-field" onClick={() => setFromCalendarOpen(true)}>
                        <span className="mobile-date-label">From</span>
                        <span className="mobile-date-val">{formatDateStr(Array.isArray(dateRange) ? dateRange[0] : null)}</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                      </div>
                      <div className="mobile-date-field" onClick={() => setToCalendarOpen(true)}>
                        <span className="mobile-date-label">To</span>
                        <span className="mobile-date-val">{formatDateStr(Array.isArray(dateRange) ? dateRange[1] : null)}</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                      </div>
                      <div style={{ opacity: 0, height: 0, overflow: 'hidden', position: 'absolute', pointerEvents: 'none' }}>
                        <DatePicker
                          open={fromCalendarOpen}
                          onClose={() => setFromCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={Array.isArray(dateRange) && dateRange[0] ? dateRange[0] : new Date()}
                          onChange={(val) => {
                            if (val) {
                              const endDate = Array.isArray(dateRange) && dateRange[1] ? dateRange[1] : new Date();
                              handleSelect([new Date(val), endDate]);
                            }
                            setFromCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                        <DatePicker
                          open={toCalendarOpen}
                          onClose={() => setToCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={Array.isArray(dateRange) && dateRange[1] ? dateRange[1] : new Date()}
                          onChange={(val) => {
                            if (val) {
                              const startDate = Array.isArray(dateRange) && dateRange[0] ? dateRange[0] : new Date();
                              handleSelect([startDate, new Date(val)]);
                            }
                            setToCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="invo-date-range-cal" ref={dateRangeRef}>
                      {isLoading ? (
                        <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range" style={{ width: "100%" }}>
                          <div
                            style={{
                              width: "100%",
                              height: "43px",
                              backgroundColor: "#e5e7eb",
                              border: "0.2px solid rgba(106, 121, 136, 0.7)",
                              borderRadius: "5px",
                              padding: "11px 36px 16px 12px",
                              animation: "pulse 1.5s ease-in-out infinite",
                              boxSizing: "border-box",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "180px",
                                height: "19px",
                                backgroundColor: "rgba(255, 255, 255, 0.6)",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="date-picker-outer date-picker-outer-all">
                          <div className="custoom-icon-calender custoom-icon-calender-all">
                            <DateRangePicker
                              format="dd/MM/yyyy"
                              value={dateRange}
                              onChange={handleSelect}
                              isoWeek={appSettings?.weekStartDay === 'Monday'}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {dateRangeIsValid && (
                    <span className="text-red-500 text-xs italic">
                      Date Range Cannot be empty
                    </span>
                  )}
                </div>
                <div className="invo-date-issueme">
                  <div className="invo-date-issue-tile">Issue Date</div>
                  {isMobile ? (
                    <div className="mobile-date-field" onClick={() => setIssueCalendarOpen(true)}>
                      <span className="mobile-date-val">{formatDateStr(issueDate)}</span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      <div style={{ opacity: 0, height: 0, overflow: 'hidden', position: 'absolute', pointerEvents: 'none' }}>
                        <DatePicker
                          open={issueCalendarOpen}
                          onClose={() => setIssueCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={issueDate}
                          onChange={(val) => {
                            if (val) handleIssueDateChange(val);
                            setIssueCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="invo-date-due-cal">
                      <div className="calender-date-due-pic" ref={issueDateRef}>
                        {isLoading ? (
                          <div className="custoom-icon-calender custoom-icon-calender-all" style={{ width: "100%" }}>
                            <div
                              style={{
                                width: "100%",
                                height: "43px",
                                backgroundColor: "#e5e7eb",
                                border: "0.2px solid rgba(106, 121, 136, 0.7)",
                                borderRadius: "5px",
                                paddingLeft: "36px",
                                paddingRight: "12px",
                                paddingTop: "11px",
                                paddingBottom: "12px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                boxSizing: "border-box",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "80px",
                                  height: "19px",
                                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="date-picker-outer date-picker-outer-all expense-create-page-date">
                            <div className="custoom-icon-calender custoom-icon-calender-all non-editable-calendar">
                              <DatePicker
                                oneTap
                                ranges={ranges}
                                format="dd/MM/yyyy"
                                value={issueDate}
                                onChange={handleIssueDateChange}
                                placement="auto"
                                className="invoice-filter-top-date"
                                required
                                isoWeek={appSettings.weekStartDay === 'Monday'}
                                readOnly
                                caretAs={CalendarIcon}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      {issueDateIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Issue Date Cannot be empty
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="date-due-manual-edm">
                  <div className="invo-date-issue-tile also-for-dued-cal">
                    Due Date
                  </div>
                  {isMobile ? (
                    <div className="mobile-date-field" onClick={() => setDueCalendarOpen(true)}>
                      <span className="mobile-date-val">{formatDateStr(dueDate)}</span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      <div style={{ opacity: 0, height: 0, overflow: 'hidden', position: 'absolute', pointerEvents: 'none' }}>
                        <DatePicker
                          open={dueCalendarOpen}
                          onClose={() => setDueCalendarOpen(false)}
                          oneTap
                          format="dd/MM/yyyy"
                          value={dueDate}
                          onChange={(val) => {
                            if (val) handleDueDateChange(val);
                            setDueCalendarOpen(false);
                          }}
                          placement="auto"
                          isoWeek={appSettings?.weekStartDay === 'Monday'}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="invo-date-due-cal">
                      <div className="calender-date-due-pic" ref={dueDateRef}>
                        {isLoading ? (
                          <div className="custoom-icon-calender custoom-icon-calender-all" style={{ width: "100%" }}>
                            <div
                              style={{
                                width: "100%",
                                height: "43px",
                                backgroundColor: "#e5e7eb",
                                border: "0.2px solid rgba(106, 121, 136, 0.7)",
                                borderRadius: "5px",
                                paddingLeft: "36px",
                                paddingRight: "12px",
                                paddingTop: "11px",
                                paddingBottom: "12px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                boxSizing: "border-box",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "80px",
                                  height: "19px",
                                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="date-picker-outer date-picker-outer-all">
                            <div className="custoom-icon-calender custoom-icon-calender-all">
                              <DatePicker
                                oneTap
                                ranges={ranges}
                                format="dd/MM/yyyy"
                                value={dueDate}
                                onChange={handleDueDateChange}
                                placement="bottomEnd"
                                required
                                isoWeek={appSettings.weekStartDay === 'Monday'}
                                caretAs={CalendarIcon}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      {dueDateIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Due Date Cannot be empty
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="sheed-sec-after-headem">
              <div className="tooltip-boxmain">
                {showTooltip && (
                  <Tooltip
                    className="custom-tooltip"
                    content={[
                      {
                        heading: "Regular Invoice",
                        content:
                          "Records the products or services delivered, the total amount due, and preferred payment method",
                        headingClass: "heading1tool",
                        contentClass: "content1tool",
                      },
                      {
                        heading: "Reinbursement Invoice",
                        content:
                          "Used when the subject is paid back for expenses.",
                        headingClass: "heading1tool second-toolhead",
                        contentClass: "content1tool",
                      },
                    ]}
                  />
                )}
              </div>
              <div className="inp-sec2-with2">
                <div className="input-field-inof">
                  <label htmlFor="invoice-title">User Name</label>
                  {isLoading ? (
                    <div
                      style={{
                        height: "40px",
                        backgroundColor: "#e5e7eb",
                        border: "0.5px solid #b4b4b4",
                        borderRadius: "5px",
                        paddingLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    >
                      <div
                        style={{
                          width: "150px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  ) : (
                    <input
                      type="text"
                      id="user-name"
                      className="read-only-input"
                      name="user-name"
                      value={userName || ""}
                      required
                      readOnly
                    />
                  )}
                </div>
                <div className="input-field-inof">
                  <label htmlFor="bank-account">Bank Account</label>
                  {(isLoading || isBankLoading) ? (
                    <div
                      className="custom-dropdown-user-new-outer"
                      style={{
                        pointerEvents: "none",
                        cursor: "default",
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <div
                        className="custom-dropdown-user-new"
                        style={{
                          backgroundColor: "#e5e7eb",
                          border: "0.2px solid rgba(106, 121, 136, 0.7)",
                          borderRadius: "7px",
                          width: "100%",
                          height: "43px",
                          paddingLeft: "16px",
                          paddingRight: "40px",
                          display: "flex",
                          alignItems: "center",
                          animation: "pulse 1.5s ease-in-out infinite",
                          boxSizing: "border-box",
                          position: "relative",
                          backgroundImage: "none",
                        }}
                      >
                        <span
                          style={{
                            width: "150px",
                            height: "19px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                            display: "inline-block",
                          }}
                        />
                      </div>
                    </div>
                  ) : bankDetails.length > 0 ? (
                    <div ref={bankAccountDropdownRef} className="custom-dropdown-user-new-outer">
                      <div className="selected-option custom-dropdown-user-new" onClick={handleToggleDropdown}>
                        {invoiceBankListName ? (
                          <>
                            {`${bankDetails.find((bank) => `${bank.id}_${bank.currency}` === invoiceBankListName)?.details.accountNumber || ''}`}
                            {`${bankDetails.find((bank) => `${bank.id}_${bank.currency}` === invoiceBankListName)?.details.accountNumber &&
                              bankDetails.find((bank) => `${bank.id}_${bank.currency}` === invoiceBankListName)?.details.IBAN
                              ? ' '
                              : ''
                              }`}
                            {`${bankDetails.find((bank) => `${bank.id}_${bank.currency}` === invoiceBankListName)?.details.IBAN || ''} (${invoiceBankCurrency})`}
                          </>
                        ) : 'Select Bank'}
                      </div>
                      {bankAccountDropdownOpen && (
                        <div className="custom-dropdown-new">
                          <input
                            type="text"
                            className="search-bar"
                            placeholder="Search..."
                            value={searchBankAccountTerm}
                            onChange={handleSearchInputChange}
                          />
                          <ul className="bank-account-list">
                            {filteredBankDetails.length > 0 ? (
                              filteredBankDetails.map((bank) => (
                                <li
                                  key={`${bank.id}_${bank.currency}`}
                                  onClick={() => handleSelectOption(`${bank.id}_${bank.currency}`)}
                                >
                                  {`${bank.details.accountNumber || ''}${bank.details.accountNumber &&
                                    bank.details.IBAN
                                    ? ' '
                                    : ''
                                    }${bank.details.IBAN || ''} (${bank.currency})`}
                                </li>
                              ))
                            ) : (
                              <li>No results found</li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {userName && (
                        <>
                          <div className="no-acccount-link">
                            No bank account is linked to this account.{" "}
                            <a onClick={(e) => { e.preventDefault(); addBank(); }}>
                              Click here to add one.
                            </a>
                          </div>
                          <Modal
                            className="delete-modal"
                            isOpen={modalIsOpen}
                            onRequestClose={closeModal}
                            contentLabel="No Bank Modal"
                            style={{
                              content: {
                                height: "41%",
                                width: "30%",
                                position: "fixed",
                                top: "40%",
                                left: "50%",
                                parent: document.querySelector(".admin-outer.time.tracker"),
                              },
                            }}
                          >
                            <div className="delete-modal-content">
                              <div className="outter-modal-main">
                                <a className="close-image-clr1" onClick={closeModal}>
                                  <img src={crssrImage} alt="Close Icon" />
                                </a>
                              </div>
                              <h2>No Bank Registered</h2>
                              <p>No Bank Registered in this Account. Please add a bank account to proceed further.</p>
                              <div className="delete-modal-buttons">
                                <button className="buttons-approved" onClick={addBank}>
                                  Add Bank
                                </button>
                                <button onClick={closeModal}>Cancel</button>
                              </div>
                            </div>
                          </Modal>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="inp-sec2-with2 inp-sec2-with2-one">
                <div className="input-field-inof">
                  <label htmlFor="invoice-title">Invoice Title</label>
                  {isLoading ? (
                    <div
                      style={{
                        height: "40px",
                        backgroundColor: "#e5e7eb",
                        border: "0.5px solid #b4b4b4",
                        borderRadius: "5px",
                        paddingLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    >
                      <div
                        style={{
                          width: "200px",
                          height: "18px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      <input
                        type="text"
                        id="invoice-title"
                        placeholder="Enter invoice Title"
                        name="invoice-title"
                        onChange={(e) => setTitle(e.target.value)}
                        value={title || ""}
                        required
                        className={titleIsValid ? "input-validation-error" : ""}
                        ref={titleRef}
                      />
                      {titleIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Title Cannot be empty
                        </span>
                      )}
                    </>
                  )}
                </div>

              </div>

              {isMobile ? (
                <div className="mobile-line-items-section" style={{ borderTop: '1px solid #EEF2F6', paddingTop: '20px', marginTop: '20px' }}>
                  <div className="mobile-line-items-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px 16px 20px' }}>
                    <h3 className="mobile-line-items-title" style={{ fontSize: '18px', fontWeight: '700', color: '#1E293B', margin: 0 }}>Line Items</h3>
                    <button
                      type="button"
                      className="add-item-button"
                      onClick={(e) => {
                        e.preventDefault();
                        setNewLineModalOpen(true);
                      }}
                    >
                      <img src={addicoplus} alt="addicon" /> Add Item
                    </button>
                  </div>
                  {productDetails.some(p => p.description || p.cost || (p.amount && p.amount !== "00.00" && p.amount !== "0.00")) && (
                    <div className="mobile-line-items-list" style={{ padding: '0 20px 8px 20px' }}>
                      {productDetails
                        .filter(p => p.description || p.cost || (p.amount && p.amount !== "00.00" && p.amount !== "0.00"))
                        .map((product, index) => (
                          <div key={index} className="mobile-line-item-card" style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '14px 16px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                              <div style={{ fontSize: '15px', fontWeight: '600', color: '#1E293B' }}>{product.description || "Line Item"}</div>
                              <div style={{ fontSize: '13px', color: '#64748B', marginTop: '4px' }}>
                                Cost: ${product.cost || "0"} | VAT: {product.tax || "0"}%
                              </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <span style={{ fontSize: '15px', fontWeight: '700', color: '#1E293B' }}>${product.amount || "0.00"}</span>
                              <button
                                type="button"
                                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                                onClick={() => handleRemoveRow(index)}
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2">
                                  <polyline points="3 6 5 6 21 6"></polyline>
                                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                              </button>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              ) : (
                invType === 'Regular' ? (
                <div className="detail-add-parteditmanual">
                  <table className="invoice-table-editmanual">
                    <thead className="the-abantant-edittxh">
                      <tr>
                        <th>Description</th>
                        <th>Cost</th>
                        <th>VAT %</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails.map((product, index) => (
                        <tr key={index}>
                          <td className="description-manual">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "120px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <>
                                <input
                                  type="text"
                                  list="projectOptions"
                                  value={product.description || ""}
                                  name="description"
                                  onChange={(e) => handleInputChange(e, index, "description")}
                                  required
                                  className={descriptionIsValid ? "input-validation-error" : ""}
                                  placeholder="Description"
                                  ref={descriptionRef}
                                  autoComplete="off"
                                />
                                {selUserCategory !== userCategory.Vendor && (
                                  <datalist id="projectOptions" style={{ position: 'absolute', top: '20%', left: 0 }}>
                                    <option value="">Select Project</option>
                                    {projectId
                                      .slice()
                                      .sort((a, b) => a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase()))
                                      .map((project) => (
                                        <option
                                          key={project._id}
                                          value={project.project_name}
                                        >
                                          {project.project_name}
                                        </option>
                                      ))}
                                  </datalist>
                                )}

                              </>
                            )}
                          </td>
                          <td className="edit-manual-costtr">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "80px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <input
                                type="number"
                                step="any"
                                data-message="Please add Cost"
                                name="cost"
                                min="0"
                                data-no={index + 1}
                                required
                                placeholder="Cost"
                                onChange={(e) =>
                                  handleInputChange(e, index, "cost")
                                }
                                className={costIsValid ? "input-validation-error" : ""}
                                value={product.cost || ""}
                                ref={costRef}
                                onWheel={numberInputOnWheelPreventChange}
                              />
                            )}
                          </td>
                          <td className="editmanual-vattd">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <input
                                type="number"
                                step="any"
                                data-message="Please add VAT"
                                name="tax"
                                min="0"
                                data-no={index + 1}
                                required
                                placeholder="VAT %"
                                onChange={(e) => handleInputChange(e, index, "tax")}
                                className={taxIsValid ? "input-validation-error" : ""}
                                value={product.tax || ""}
                                ref={taxRef}
                                onWheel={numberInputOnWheelPreventChange}
                              />
                            )}
                          </td>
                          <td className="editmanual-amount-tr">
                            <div className="amount-cell">
                              {isLoading ? (
                                <div
                                  style={{
                                    width: "100px",
                                    height: "18px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              ) : (
                                <span className="delete-icon">
                                  {invoiceBankCurrency ? (
                                    <>
                                      {product.amount ? (
                                        <>
                                          {new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: invoiceBankCurrency,
                                          }).format(product.amount)}
                                        </>
                                      ) : (
                                        <>
                                          {new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: invoiceBankCurrency,
                                          }).format("00.00")}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {product.amount ? (
                                        <span>{product.amount}</span>
                                      ) : (
                                        <span>00.00</span>
                                      )}
                                    </>
                                  )}
                                  {productDetails.length !== 1 && (
                                    <button className="del-icon-main-sel"
                                      type="button"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      <img src={dletImage} alt="delete-icon" />{" "}
                                    </button>
                                  )}
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button className="add-item-button" onClick={handleAddRow}>
                    <img src={addicoplus} alt="addicon" /> Add Item
                  </button>
                </div>
              ) : (
                <div className="detail-add-parteditmanual">
                  <table className="invoice-table-editmanual">
                    <thead className="the-abantant-edittxh ssss">
                      <tr>
                        <th>Descriptions</th>
                        <th>Category</th>
                        <th>VAT %</th>
                        <th>Cost</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productDetails.map((product, index) => (
                        <tr key={index}>
                          <td className="description-manual">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "120px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <input
                                type="text"
                                data-message="Please add Description"
                                name="description"
                                required
                                placeholder="Description"
                                onChange={(e) =>
                                  handleInputChange(e, index, "description")
                                }
                                className={descriptionIsValid ? "input-validation-error" : ""}
                                value={product.description || ""}
                                ref={descriptionRef}
                              />
                            )}
                          </td>
                          <td className="description-manual">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "120px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <select
                                type="select"
                                value={product.expenseCategory || ""}
                                name="expenseCategory"
                                onChange={(e) =>
                                  handleInputChange(e, index, "expenseCategory")
                                }
                                required
                                className={expenseCategoryIsValid ? "input-validation-error" : ""}
                                placeholder="Expense Category"
                                ref={descriptionRef}
                              >
                                <option value="">Select Category</option>

                                {expenseCategory?.data && expenseCategory?.data
                                  .slice()
                                  .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                  .map((expense) => (
                                    <option
                                      key={expense._id}
                                      value={expense.exp_category_name}
                                    >
                                      {expense.exp_category_name}
                                    </option>
                                  ))}
                              </select>
                            )}
                          </td>
                          <td className="editmanual-vattd">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "60px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <input
                                type="number"
                                step="any"
                                data-message="Please add VAT"
                                name="tax"
                                min="0"
                                data-no={index + 1}
                                required
                                placeholder="VAT %"
                                onChange={(e) => handleInputChange(e, index, "tax")}
                                className={taxIsValid ? "input-validation-error" : ""}
                                value={product.tax || ""}
                                ref={taxRef}
                                onWheel={numberInputOnWheelPreventChange}
                              />
                            )}
                          </td>
                          <td className="edit-manual-costtr">
                            {isLoading ? (
                              <div
                                style={{
                                  width: "100%",
                                  height: "43px",
                                  backgroundColor: "#e5e7eb",
                                  border: "0.5px solid #B4B4B4",
                                  borderRadius: "5px",
                                  paddingLeft: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              >
                                <div
                                  style={{
                                    width: "80px",
                                    height: "18px",
                                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            ) : (
                              <input
                                type="number"
                                step="any"
                                data-message="Please add Cost"
                                name="cost"
                                min="0"
                                data-no={index + 1}
                                required
                                placeholder="Cost"
                                onChange={(e) =>
                                  handleInputChange(e, index, "cost")
                                }
                                className={costIsValid ? "input-validation-error" : ""}
                                value={product.cost || ""}
                                ref={costRef}
                                onWheel={numberInputOnWheelPreventChange}
                              />
                            )}
                          </td>

                          <td className="editmanual-amount-tr">
                            <div className="amount-cell">
                              {isLoading ? (
                                <div
                                  style={{
                                    width: "100px",
                                    height: "18px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              ) : (
                                <button className="delete-icon">
                                  {invoiceBankCurrency ? (
                                    <>
                                      {product.amount ? (
                                        <>
                                          {new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: invoiceBankCurrency,
                                          }).format(product.amount)}
                                        </>
                                      ) : (
                                        <>
                                          {new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: invoiceBankCurrency,
                                          }).format("00.00")}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {product.amount ? (
                                        <span>{product.amount}</span>
                                      ) : (
                                        <span>00.00</span>
                                      )}
                                    </>
                                  )}
                                  {productDetails.length !== 1 && (
                                    <button className="del-icon-main-sel"
                                      type="button"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      <img src={dletImage} alt="delete-icon" />{" "}
                                    </button>
                                  )}
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button className="add-item-button" onClick={handleAddRow}>
                    <img src={addicoplus} alt="addicon" /> Add Item
                  </button>
                </div>
              ))}
            </div>
            <div className="sec-after-tab-ls-part">
              <div className="sec-withother-and-add">
                <div className="other-secp1">
                  <div className="other-head1">Other comments</div>
                  <div className="other-subhead1">
                    {isLoading ? (
                      <div
                        style={{
                          width: "100%",
                          minHeight: "80px",
                          backgroundColor: "#e5e7eb",
                          border: "0.5px solid #b4b4b4",
                          borderRadius: "5px",
                          padding: "10px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      >
                        <div
                          style={{
                            width: "200px",
                            height: "14px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                            marginBottom: "8px",
                          }}
                        />
                        <div
                          style={{
                            width: "150px",
                            height: "14px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        />
                      </div>
                    ) : (
                      <textarea
                        type="text"
                        className=""
                        placeholder="Comment here"
                        value={otherComnt || ""}
                        onChange={(e) => setOtherComnt(e.target.value || "")}
                        style={{ resize: "none" }}
                      ></textarea>
                    )}
                  </div>
                </div>
                <div className="file-add-p1-attachment">
                  <div className="attachment-head">
                    Attachments
                    {/* {(filesToRemove.length > 0 || invFiles.length > 0) && (
                      <span style={{
                        fontSize: '12px',
                        color: '#666',
                        marginLeft: '10px',
                        fontWeight: 'normal'
                      }}>
                        ({filesToRemove.length} to remove, {invFiles.length} to add)
                      </span>
                    )} */}
                  </div>
                  {isLoading ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "200px",
                          height: "30px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                      <div
                        style={{
                          width: "180px",
                          height: "30px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      {/* Existing Files */}
                      {existingFiles && existingFiles.length > 0 && (
                        <div className="existing-files-section">
                          {/* <div className="existing-files-label">Current Attachments:</div> */}
                          {existingFiles.map((file, index) => (
                            <div key={`existing-${index}`} className="uploaded-file-item">
                              <span
                                className="file-name"
                                onClick={() => downloadExistingFile(file)}
                                style={{
                                  cursor: 'pointer',
                                  color: '#6479f9',
                                  maxWidth: '200px',
                                  display: 'inline-block',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                                title={`${file} - Click to download`}
                              >
                                {file.length > 25 ? `${file.substring(0, 25)}...` : file}
                              </span>
                              <a onClick={() => removeExistingFile(index)} > Remove </a>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* New Files Upload */}
                      {invFiles && invFiles.length > 0 && (
                        <div className="new-files-section">
                          {/* <div className="new-files-label">New Files to Upload:</div> */}
                          {invFiles.map((file, index) => (
                            <div key={`new-${index}`} className="uploaded-file-item">
                              <span
                                style={{
                                  maxWidth: '200px',
                                  display: 'inline-block',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                                title={file.name}
                              >
                                {file.name.length > 25 ? `${file.name.substring(0, 25)}...` : file.name}
                              </span>
                              <a onClick={() => removeFile(index)}>Remove</a>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Files Marked for Removal */}
                      {/* {filesToRemove && filesToRemove.length > 0 && (
                        <div className="removed-files-section" style={{ maxWidth: '250px' }}>
                          <div className="removed-files-label" style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Files to be removed:</div>
                          {filesToRemove.map((file, index) => (
                            <div key={`removed-${index}`} className="removed-file-item" style={{
                              padding: '3px 8px',
                              margin: '3px 0',
                              backgroundColor: '#ffe6e6',
                              border: '1px solid #ffcccc',
                              borderRadius: '3px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              fontSize: '11px'
                            }}>
                              <span
                                style={{
                                  color: '#cc0000',
                                  textDecoration: 'line-through',
                                  maxWidth: '250px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                                title={file}
                              >
                                {file.length > 30 ? `${file.substring(0, 30)}...` : file}
                              </span>
                              <button
                                onClick={() => undoRemoveFile(file)}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: '#0066cc',
                                  cursor: 'pointer',
                                  fontSize: '10px',
                                  padding: '2px 4px'
                                }}
                              >
                                Undo
                              </button>
                            </div>
                          ))}
                        </div>
                      )} */}

                      {/* New Files Upload */}
                      <div className="style-portion-browsetext" style={{ cursor: 'pointer' }}>
                        <label className="add-item-button-end-browse">
                          <img src={addicoplus} alt="addicon" /> Browse
                          <input
                            ref={fileInputRef}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={handleInvDocChange}
                            multiple // Allow multiple file selection
                          />
                        </label>
                        {/* <div className="upload-file-name-br">
                          {invFiles.map((file, index) => (
                            <div key={`new-${index}`} className="uploaded-file-item">
                              <span
                                style={{
                                  maxWidth: '200px',
                                  display: 'inline-block',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                                title={file.name}
                              >
                                {file.name.length > 25 ? `${file.name.substring(0, 25)}...` : file.name}
                              </span>
                              <a onClick={() => removeFile(index)}>Remove</a>
                            </div>
                          ))}
                        </div> */}
                      </div>

                      {/* Clear All Changes Button */}
                      {/* {(filesToRemove.length > 0 || invFiles.length > 0) && (
                        <div style={{ marginTop: '10px', textAlign: 'center' }}>
                          <button
                            onClick={clearAllPendingChanges}
                            style={{
                              background: 'none',
                              border: '1px solid #ccc',
                              color: '#666',
                              padding: '5px 10px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            Clear All Changes
                          </button>
                        </div>
                      )} */}
                    </>
                  )}
                </div>
              </div>
              <div className="invo-total-specialcard">
                <div className="specialcard-outter">
                  <table className="to-ino-to-special">
                    <tbody>
                      <tr>
                        <th className="sub-lem-tb-fisl">Subtotal</th>
                        <td className="sub-price-tb-fisl">
                          {isLoading ? (
                            <div
                              style={{
                                width: "100px",
                                height: "18px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          ) : (
                            <>
                              {invoiceBankCurrency ? (
                                <>
                                  {new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: invoiceBankCurrency,
                                  }).format(subTotal)}
                                </>
                              ) : (
                                <span>{subTotal}</span>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="sub-vat-tb-fisl">VAT</th>
                        <td className="sub-vatpr-tb-fisl">
                          {isLoading ? (
                            <div
                              style={{
                                width: "100px",
                                height: "18px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          ) : (
                            <>
                              {invoiceBankCurrency ? (
                                <>
                                  {new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: invoiceBankCurrency,
                                  }).format(taxTotal)}
                                </>
                              ) : (
                                <span>{taxTotal}</span>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="sub-invoto-tb-fisl">Invoice Total</th>
                        <td className="sub-ivvoto-price-tb-fisl">
                          {isLoading ? (
                            <div
                              style={{
                                width: "100px",
                                height: "18px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          ) : (
                            <>
                              {invoiceBankCurrency ? (
                                <>
                                  {new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: invoiceBankCurrency,
                                  }).format(total)}
                                </>
                              ) : (
                                <span>{total}</span>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {isMobile ? (
                    <div className="mobile-submit-bar-wrapper">
                      <button
                        className="largecreate-invo-btn"
                        type="submit"
                        disabled={updateIsLoading}
                      >
                        {updateIsLoading ? "Updating Invoice..." : "Update Invoice"}
                      </button>
                    </div>
                  ) : (
                    <button
                      className="largecreate-invo-btn"
                      type="submit"
                      disabled={updateIsLoading}
                    >
                      {updateIsLoading ? "Updating Invoice..." : "Update Invoice"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Mobile New Line Item Modal */}
          <Modal
            className="mobile-action-modal"
            overlayClassName="mobile-sheet-overlay"
            isOpen={newLineModalOpen}
            onRequestClose={() => setNewLineModalOpen(false)}
            closeTimeoutMS={480}
            style={{
              content: {
                position: "fixed",
                bottom: "0",
                top: "auto",
                left: "0",
                right: "0",
                width: "100%",
                maxWidth: "100%",
                borderRadius: "24px 24px 0 0",
                padding: "0 0 28px 0",
                border: "none",
                background: "#FFFFFF",
                transform: "none",
                inset: "auto 0px 0px 0px",
                zIndex: 1000,
              },
            }}
          >
            <div className="mobile-bottom-sheet-content">
              <div className="mobile-bottom-sheet-header">
                <button
                  type="button"
                  className="mobile-sheet-close-circle"
                  onClick={() => setNewLineModalOpen(false)}
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <h3 className="mobile-sheet-title">New Line Item</h3>
              </div>
              <form onSubmit={handleAddLineItemSubmit} className="mobile-new-line-form" style={{ padding: '20px 24px' }}>
                <div className="form-group-1modal" style={{ paddingBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748B', marginBottom: '8px' }}>Description</label>
                  <input
                    type="text"
                    placeholder="Write here"
                    value={newLineDesc}
                    onChange={(e) => setNewLineDesc(e.target.value)}
                    style={{ width: '100%', height: '48px', borderRadius: '12px', border: '1px solid #E2E8F0', padding: '0 16px', fontSize: '15px', color: '#1E293B', boxSizing: 'border-box' }}
                  />
                </div>
                <div className="form-group-1modal" style={{ paddingBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748B', marginBottom: '8px' }}>Cost</label>
                  <input
                    type="number"
                    placeholder="$"
                    value={newLineCost}
                    onChange={(e) => setNewLineCost(e.target.value)}
                    style={{ width: '100%', height: '48px', borderRadius: '12px', border: '1px solid #E2E8F0', padding: '0 16px', fontSize: '15px', color: '#1E293B', boxSizing: 'border-box' }}
                  />
                </div>
                <div className="form-group-1modal" style={{ paddingBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748B', marginBottom: '8px' }}>VAT%</label>
                  <input
                    type="number"
                    placeholder="$"
                    value={newLineVat}
                    onChange={(e) => setNewLineVat(e.target.value)}
                    style={{ width: '100%', height: '48px', borderRadius: '12px', border: '1px solid #E2E8F0', padding: '0 16px', fontSize: '15px', color: '#1E293B', boxSizing: 'border-box' }}
                  />
                </div>
                <button
                  type="submit"
                  className="create-button modalsubmitbtn-1"
                  style={{ width: '100%', height: '48px', background: '#6479F8', borderRadius: '12px', color: '#FFFFFF', fontSize: '15px', fontWeight: '600', border: 'none', cursor: 'pointer', boxShadow: '0 4px 14px rgba(100, 121, 248, 0.35)' }}
                >
                  Add Line Item
                </button>
              </form>
            </div>
          </Modal>
        </div>
      </form>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoiceEditManual;